import { Model } from 'app/model/backendmodel';
import { writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { AzureSearchSink } from 'app/model/pipeline/copysink/azure-search.copysink';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureSearchSink),
    asynchronous: true,
    adapts: {
        type: '*',
        writeBehavior: __IS_FABRIC_DPE__ ? undefined : '*',
        indexAction: __IS_FABRIC_DPE__ ? '*' : undefined,
        writeBatchSize: '*',
        maxConcurrentConnections: '*',
        structure: '*'
    }
})
export class AzureSearchSinkAdapter extends CopySinkAdapter<AzureSearchSink, Model.AzureSearchIndexSink> {

    protected override async _toResource(model: AzureSearchSink): Promise<Model.AzureSearchIndexSink> {
        const result: Model.AzureSearchIndexSink = {
            type: 'AzureSearchIndexSink'
        };
        result.writeBatchSize = ValueAdapter.toResource(model, AzureSearchSink.WRITE_BATCH_SIZE);
        if (__IS_FABRIC_DPE__) {
            result.indexAction = ValueAdapter.toResource(model, AzureSearchSink.WRITE_BEHAVIOR);
        } else {
            result.writeBehavior = ValueAdapter.toResource(model, AzureSearchSink.WRITE_BEHAVIOR);
        }

        CopySinkAdapter.maxConcurrentConnectionsToResource(model, result);
        CopySinkAdapter.toCommonCopySinkResource(model, result, this.context);
        return result;
    }

    protected override async _toModel(resource: Model.AzureSearchIndexSink, owner: Activity): Promise<AzureSearchSink> {
        const result = Owned.create<AzureSearchSink>(Metamodel.modelFor(AzureSearchSink), owner);
        ValueAdapter.toModel(result, AzureSearchSink.WRITE_BATCH_SIZE, resource.writeBatchSize);

        // handle upper case and lower case
        let writeBehavior = __IS_FABRIC_DPE__ ? resource.indexAction : resource.writeBehavior;
        if (writeBehavior && typeof writeBehavior === 'string') {
            const lowerCaseValue = writeBehavior.toLowerCase();
            switch (lowerCaseValue) {
                case writeBehaviorOptionValues.merge:
                    writeBehavior = writeBehaviorOptionValues.merge;
                    break;
                case writeBehaviorOptionValues.upload:
                    writeBehavior = writeBehaviorOptionValues.upload;
                    break;
                default:
                    break;
            }
        }
        ValueAdapter.toModel(result, AzureSearchSink.WRITE_BEHAVIOR, writeBehavior);

        CopySinkAdapter.maxConcurrentConnectionsToModel(resource, result);
        CopySinkAdapter.toCommonCopySinkModel(result, resource);

        return result;
    }
}
